import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import apiService from '../services/apiService';
import authService from '../services/authService';

const Login = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    student_id: '',
    password: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  // Get the page user was trying to access before login
  const from = location.state?.from?.pathname || '/application-form';

  // Redirect if already authenticated
  useEffect(() => {
    if (authService.isAuthenticated()) {
      navigate(from, { replace: true });
    }
  }, [navigate, from]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (error) {
      setError('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');
    
    try {
      const response = await apiService.studentLogin(formData);

      if (response.success && response.data.status === 'success') {
        // Store authentication data
        const { token, student } = response.data;
        authService.setAuthData(token, student);
        
        // Dispatch custom event to notify header of login success
        window.dispatchEvent(new CustomEvent('loginSuccess'));
        
        // Redirect to the page user was trying to access
        navigate(from, { replace: true });
      } else {
        setError(response.data.message || 'Login failed. Please check your credentials.');
      }
    } catch (error) {
      console.error('Login error:', error);
      setError(apiService.handleApiError(error));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div className="login-container" style={{
        background: 'white',
        padding: '40px',
        borderRadius: '10px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px'
      }}>
        <div className="text-center mb-4">
          <h2 style={{ color: '#333', marginBottom: '10px' }}>Student Login</h2>
          <p style={{ color: '#666', fontSize: '14px' }}>
            Access your application form
          </p>
        </div>

        {error && (
          <div className="alert alert-danger" role="alert" style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '10px',
            borderRadius: '5px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="student_id" className="form-label" style={{ fontWeight: '500', color: '#333' }}>
              Student ID
            </label>
            <input
              type="text"
              className="form-control"
              id="student_id"
              name="student_id"
              placeholder="Enter your Student ID (e.g., TEST-001)"
              value={formData.student_id}
              onChange={handleInputChange}
              required
              style={{
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '14px'
              }}
            />
          </div>

          <div className="mb-4">
            <label htmlFor="password" className="form-label" style={{ fontWeight: '500', color: '#333' }}>
              Password
            </label>
            <input
              type="password"
              className="form-control"
              id="password"
              name="password"
              placeholder="Enter your password"
              value={formData.password}
              onChange={handleInputChange}
              required
              style={{
                padding: '12px',
                border: '1px solid #ddd',
                borderRadius: '5px',
                fontSize: '14px'
              }}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={isLoading}
            style={{
              padding: '12px',
              backgroundColor: '#007bff',
              border: 'none',
              borderRadius: '5px',
              color: 'white',
              fontSize: '16px',
              fontWeight: '500',
              cursor: isLoading ? 'not-allowed' : 'pointer',
              opacity: isLoading ? 0.7 : 1
            }}
          >
            {isLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Logging in...
              </>
            ) : (
              'Login'
            )}
          </button>
        </form>

        <div className="text-center mt-4">
          <p style={{ fontSize: '12px', color: '#666' }}>
            Need help? Contact our support team
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
